import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ema_1: 0,
  ema_2: 0,
  intervalSelected: ''
};

const emaSelectionSlicer = createSlice({
  name: 'emaSelection',
  initialState,
  reducers: {
    setEma_1: (state, action) => {
      state.ema_1 = action.payload;
    },
    setEma_2: (state, action) => {
      state.ema_2 = action.payload;
    },
    setIntervalSelected: (state, action) => {
      state.intervalSelected = action.payload;
    },
  },
  reset : () => initialState
});

export const { setEma_1, setEma_2, setIntervalSelected } = emaSelectionSlicer.actions;
export default emaSelectionSlicer.reducer;

